import * as z from "zod/v4";

export const deleteCustomDomain = {
  name: "deleteCustomDomain" as const,
  input: z.object({ domain: z.string() }),
  output: z.null(),
};
